import { render } from "./addShell.vue?vue&type=template&id=09d98c0b&scoped=true"
import script from "./addShell.vue?vue&type=script&lang=js"
export * from "./addShell.vue?vue&type=script&lang=js"

import "./addShell.vue?vue&type=style&index=0&id=09d98c0b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d98c0b"]])

export default __exports__